export { default as tiscAccordion } from './Elements/tiscAccordion.vue';
export { default as tiscButton } from './Elements/tiscButton.vue';
export { default as tiscCard } from './Elements/tiscCard.vue';
export { default as tiscSection } from './Elements/tiscSection.vue';
export { default as tiscMessage } from './Elements/tiscMessage.vue';
export { default as tiscModal } from './Elements/tiscModal.vue';
export { default as tiscTable } from './Elements/tiscTable.vue';
export { default as tiscTab } from './Elements/tiscTab.vue';
export { default as tiscTabs } from './Elements/tiscTabs.vue';
export { default as tiscPagination } from './Elements/tiscPagination.vue';
export { default as tiscHeader } from './Elements/tiscHeader.vue';

export { default as tiscInput } from './Forms/tiscInput.vue';
export { default as tiscFile } from './Forms/tiscFile.vue';
export { default as tiscOption } from './Forms/tiscOption.vue';

export { default as tiscContentSidebar } from './Vana/tiscContentSidebar.vue';
export { default as tiscFlag } from './Vana/tiscFlag.vue';
export { default as tiscFooter } from './Vana/tiscFooter.vue';
export { default as tiscResults } from './Vana/tiscResults.vue';
export { default as tiscSkeleton } from './Vana/tiscSkeleton.vue';

export { default as tiscBurger } from './Menus/tiscBurger.vue';